<template>
  <t-dialog header="选择保存类型" :visible="true" :closeOnOverlayClick="false" :onClose="handleClose" width="80%">
    <div>
      <t-tabs v-model="activeName" @tab-click="handleClick">
        <t-tab-panel label="更新当前看板" value="updateComponent" :destroyOnHide="false" v-if="!!formDataComponent.id">
          <LtvAnalysisSaveComponentForm
            ref="refFormUpdateComponent"
            save-type="update"
            :board-info="boardInfo"
            :form="formDataComponent"
          ></LtvAnalysisSaveComponentForm>
        </t-tab-panel>
        <t-tab-panel :label="newBoardCompLabel" value="newComponent" :destroyOnHide="false">
          <LtvAnalysisSaveComponentForm
            ref="refFormNewComponent"
            save-type="new"
            :board-info="boardInfo"
            :form="formDataComponent"
          ></LtvAnalysisSaveComponentForm>
        </t-tab-panel>

        <!--<t-tab-panel label="更新当前书签" value="updateBookmark" v-if="formDataBookmark.id">-->
        <!--  <t-form-->
        <!--    label-width="100px"-->
        <!--    ref="formBookmarkUpdate"-->
        <!--    @submit.native.prevent-->
        <!--    :rules="rulesBookmark"-->
        <!--    :model="formBookmarkUpdate"-->
        <!--  >-->
        <!--    <t-form-item label="书签名称" name="bookmarkName">-->
        <!--      <t-input v-model="formBookmarkUpdate.bookmarkName"></t-input>-->
        <!--    </t-form-item>-->
        <!--    <t-form-item label="备注" name="remark">-->
        <!--      <t-textarea v-model="formBookmarkUpdate.remark"></t-textarea>-->
        <!--    </t-form-item>-->
        <!--  </t-form>-->
        <!--</t-tab-panel>-->
        <!--<t-tab-panel :label="newBookmarkLabel" value="newBookmark">-->
        <!--  <t-form-->
        <!--    label-width="100px"-->
        <!--    ref="formBookmarkNew"-->
        <!--    @submit.native.prevent-->
        <!--    :rules="rulesBookmark"-->
        <!--    :data="formBookmarkNew"-->
        <!--  >-->
        <!--    <t-form-item label="书签名称" name="bookmarkName">-->
        <!--      <t-input v-model="formBookmarkNew.bookmarkName"></t-input>-->
        <!--    </t-form-item>-->
        <!--    <t-form-item label="备注" name="remark">-->
        <!--      <t-textarea v-model="formBookmarkNew.remark"></t-textarea>-->
        <!--    </t-form-item>-->
        <!--  </t-form>-->
        <!--</t-tab-panel>-->
      </t-tabs>
    </div>
    <div slot="footer" class="dialog-footer">
      <t-button variant="outline" @click="handleClose">取消</t-button>
      <t-button theme="primary" :loading="loading" @click="handleOK">保存</t-button>
    </div>
  </t-dialog>
</template>
<script>
import { pick } from 'lodash';
import { calLayoutParams } from '@/utils/helper';
import LtvAnalysisSaveComponentForm from './save-component-form.vue';

export default {
  components: {
    LtvAnalysisSaveComponentForm,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    formDataBookmark: {
      type: Object,
      required: true,
    },
    formDataComponent: {
      type: Object,
      required: true,
    },
    boardInfo: {
      type: Object,
      required: true,
    },
  },
  watch: {
    formDataBookmark() {
      //
    },
  },
  created() {
    // eslint-disable-next-line max-len
    const tmpBookmarkObj = pick(this.formDataBookmark, ['id', 'bookmarkName', 'remark']); // 这里可能会有问题，undefined的不会pick到吧？
    Object.assign(this.formBookmarkUpdate, tmpBookmarkObj);

    if (this.formDataComponent.id) {
      this.activeName = 'updateComponent';
      this.newBoardCompLabel = '添加到其他看板';
    } else if (this.formDataBookmark.id) {
      this.activeName = 'updateBookmark';
      this.newBookmarkLabel = '保存为新书签';
    } else if (this.formDataComponent.boardId) {
      this.activeName = 'newComponent';
    } else {
      this.activeName = 'newComponent';
    }
  },
  data() {
    return {
      activeName: '', // newBookmark, updateBookmark, newComponent, updateComponent
      newBookmarkLabel: '保存为书签',
      newBoardCompLabel: '添加到看板',

      formBookmarkNew: {
        bookmarkName: '',
        remark: '',
      },
      formBookmarkUpdate: {
        id: '',
        bookmarkName: '',
        remark: '',
      },

      rulesBookmark: {
        bookmarkName: [
          { required: true, message: '请输入书签名称', trigger: 'blur' },
          { min: 1, max: 40, message: '长度在 1 到 40 个字符', trigger: 'blur' },
        ],
        remark: [{ min: 1, max: 140, message: '长度在 1 到 140 个字符', trigger: 'blur' }],
      },
    };
  },
  methods: {
    handleClick() {
      //
    },

    handleClose() {
      this.$emit('onClose');
    },

    handleOK() {
      // eslint-disable-next-line default-case
      switch (this.activeName) {
        case 'newBookmark':
          this.handleNewBookmark();
          break;
        case 'updateBookmark':
          this.handleUpdateBookmark();
          break;
        case 'newComponent':
          this.handleNewComponent();
          break;
        case 'updateComponent':
          this.handleUpdateComponent();
          break;
      }
    },

    async handleNewComponent() {
      const valid = await this.$refs.refFormNewComponent.validate();
      if (valid === true) {
        const form = this.$refs.refFormNewComponent.getForm();
        this.fixComponentForm(form);

        const pos = this.getNewComponentPos(form);
        form.ext = JSON.stringify(pos);

        this.$emit('onSaveComponent', 'new', form);
      }
    },

    async handleUpdateComponent() {
      const valid = await this.$refs.refFormUpdateComponent.validate();
      if (valid === true) {
        const form = this.$refs.refFormUpdateComponent.getForm();
        this.fixComponentForm(form);

        this.$emit('onSaveComponent', 'update', form);
      }
    },

    fixComponentForm(form) {
      if (Array.isArray(form.secondaryIndex)) {
        form.secondaryIndex = form.secondaryIndex.join(',');
      }
      if (form.indexTabDisplay === 1) {
        if (!Array.isArray(form.indexSet)) {
          form.indexSet = [{ targetName: form.indexSet }];
        }
      } else {
        form.indexSet = null;
      }
    },

    // 保存新书签
    async handleNewBookmark() {
      const valid = await this.$refs.formBookmarkNew.validate();
      if (valid === true) {
        this.$emit('onSaveBookmark', this.formBookmarkNew);
      }
    },
    // 更新书签
    async handleUpdateBookmark() {
      const valid = await this.$refs.formBookmarkUpdate.validate();
      if (valid === true) {
        this.$emit('onSaveBookmark', this.formBookmarkUpdate);
      }
    },

    getNewComponentPos(form) {
      const componentList = this.boardInfo.componentList || [];
      const wh = calLayoutParams(form);
      // console.log('wh', wh);
      let x = 0;
      let y = 0;
      let targetItem;
      componentList.forEach(item => {
        item.ext = item.ext || '{"x": 0, "y": 0}';
        if (typeof item.ext === 'string') {
          item.ext = JSON.parse(item.ext);
        }
        item.ext.x = item.ext.x || 0;
        item.ext.y = item.ext.y || 0;
        if (item.ext.y >= y && item.ext.x >= x) {
          y = item.ext.y;
          x = item.ext.x;
          targetItem = item;
        }
      });
      if (targetItem) {
        const twh = calLayoutParams(targetItem);
        if (x + wh.w + twh.w > 4) {
          return {
            x: 0,
            y: y + twh.h,
          };
        }
        return {
          x: x + twh.w,
          y,
        };
      }
      return {
        x: 0,
        y: 0,
      };
    },
  },
};
</script>
<style lang="less" scoped>
.dialog-footer {
  margin-top: 0;
  text-align: inherit;
}
</style>
